export const page = {
  seo: {
    title: 'Site web pour votre restaurant ou établissement de restauration | Bistroo',
    description: "Un site web personnalisé pour votre restaurant, entièrement adaptable à vos besoins. En ligne en un rien de temps, 30 jours gratuits. Inclut l'optimisation SEO et un nom de domaine personnalisé.",
  },
  hero: {
    title: {
      pt1: 'Un',
      pt2: 'site web',
      pt3: 'entièrement adapté à votre restaurant',
    },
    description:
      'Le site web de Bistroo offre les outils pour créer une page d\'accueil complète favorisant les conversions, qui améliore l\'expérience de commande de vos clients du début à la fin.',
    button: 'Créer votre site web',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Facile à construire, effortless à maintenir',
      text: 'Le site web est généré sur la base des informations de votre restaurant et est facilement adaptable pour correspondre parfaitement au style et à l\'image de marque de votre restaurant.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Mis à jour automatiquement',
      text: 'Toutes les modifications que vous apportez dans le Bistroo Manager sont immédiatement répercutées sur votre site web, vous n\'avez donc pas besoin de mettre à jour manuellement les informations sur plusieurs éditeurs ou emplacements.',
      cta: '',
    },
    paragraph_3: {
      title: 'Offrez une excellente expérience client',
      text: 'Du premier clic au paiement, vos clients profitent d\'une expérience de commande bien conçue qui contribue à chaque étape. Ce qui renforce à la fois l\'expérience client et la réputation de votre restaurant.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Optimisé pour l\'utilisation en ligne et le e-commerce',
      text: 'Nos pages d\'accueil sont conçues et développées pour un référencement optimal. Atteignez le sommet des résultats de recherche organiques dans votre région ou donnez un coup de pouce à votre site web avec des publicités rentables.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Mettez vos best-sellers sous les projecteurs.',
        text: 'Vos modifications de menu et vos articles les plus vendus sont connectés de manière transparente à votre site web, sans travail supplémentaire.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Intégrations.',
        text: 'Connectez votre système de caisse ou vos outils externes préférés.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Présentez et partagez des informations importantes.',
        text: 'Communiquez clairement des informations importantes via votre site web en modifiant les paramètres dans l\'application Manager.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Formulaires de contact.',
        text: 'Acceptez des demandes via le formulaire de contact intégré.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Optimisé pour tous les canaux.',
        text: 'Tous les sites web sont optimisés pour la recherche Google et adaptés à l\'affichage sur tous types d\'appareils.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Bistroo nous fait gagner beaucoup de temps chaque jour et réduit considérablement la frustration chez les clients."',
    cta: 'Lire l\'histoire complète',
    name: 'Two-B by Mondie',
    job_title: 'Lunchroom',
  },
  faq: {
    title_pt1: 'Tout sur le',
    title_pt2: 'site Bistroo',
    items: [
      { q: 'Qu\'est-ce que le site web Bistroo pour restaurant ?', a: 'Le site web Bistroo est une page d\'accueil personnalisée pour votre établissement de restauration. Les clients y trouvent votre menu, vos horaires d\'ouverture, votre adresse et un bouton de commande direct, le tout dans votre charte graphique.' },
      { q: 'Comment créer mon site web Bistroo ?', a: 'Le site web est généré automatiquement sur la base des informations de votre compte Bistroo. Après votre inscription, vous choisissez un modèle, ajoutez votre logo et vos couleurs, et votre site est prêt à être publié.' },
      { q: 'Puis-je utiliser mon propre nom de domaine ?', a: 'Oui. Vous connectez votre propre nom de domaine au site web Bistroo afin que les clients vous trouvent via votre propre adresse, comme www.votrerestaurant.fr.' },
      { q: 'Mon site web est-il optimisé pour Google ?', a: 'Oui. Tous les sites web Bistroo sont techniquement optimisés pour les moteurs de recherche. Vous vous positionnez mieux dans les résultats de recherche locaux et sur Google Maps, afin que de nouveaux clients vous trouvent plus facilement.' },
      { q: 'Les modifications du menu sont-elles automatiquement mises à jour sur le site web ?', a: 'Oui. Les modifications apportées dans le Bistroo Manager sont immédiatement répercutées sur votre site web. Vous n\'avez jamais besoin de faire des modifications simultanément à plusieurs endroits.' },
      { q: 'Puis-je modifier le style et l\'apparence de mon site web ?', a: 'Oui. Vous adaptez les couleurs, la typographie, l\'image d\'en-tête et la mise en page via le Manager. Ainsi, le site web correspond parfaitement à l\'atmosphère de votre restaurant.' },
      { q: 'Le site web est-il accessible sur mobile ?', a: 'Oui. Tous les sites web Bistroo sont entièrement responsifs et optimisés pour les smartphones et tablettes. La plupart des visiteurs consultent les restaurants sur leur téléphone, ce qui est donc tout à fait adapté.' },
      { q: 'Puis-je ajouter un formulaire de contact à mon site web ?', a: 'Oui. Via les paramètres du site web dans le Manager, vous activez un formulaire de contact permettant aux clients de soumettre des questions, des demandes de réservation ou des demandes de traiteur.' },
      { q: 'Comment promouvoir des offres spéciales sur mon site web ?', a: 'Via le Manager, vous ajoutez des bannières, des textes promotionnels et des codes de réduction directement visibles sur votre site web. Vous communiquez ainsi toujours les dernières offres à vos visiteurs.' },
      { q: 'Quel est le coût du site web Bistroo pour restaurant ?', a: 'La page de base est incluse dans chaque formule Bistroo. Pour un site web entièrement white-label avec domaine personnalisé et options de personnalisation avancées, une formule payante est disponible.' },
    ],
  },
}
